import * as keycloakHelper from "./keycloak";

export const keycloak = keycloakHelper;
